import { formatDate } from 'devextreme/localization';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useGetCompany } from '../../../../api/company';
import { Field, Panel } from '../../../../layouts';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function StoreInformationPanel() {

	const { order } = useContext(RetailOrderContext);

	const store = useGetCompany(order.details.dealerCompanyID);
	const proxyStore = useGetCompany(order.details.proxyDealerCompanyID);

	return (
		<>
			<Panel
				header={'Store Information'}
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} >{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
				<Field label={'Fax'} visible={!!store.data?.fax}>{store.data?.fax}</Field>
				<Field label={'Proxy Store'} visible={!!order.details.proxyDealerCompanyID} >{proxyStore.data?.companyCode + ' - ' + proxyStore.data?.companyName}</Field>
				<Field label={'Sales Associate Name'} visible={!!order.details.salesAssocName}>{order.details.salesAssocName}</Field>
				<Field label={'Sales Associate Number'} visible={!!order.details.salesAssocNumber}>{order.details.salesAssocNumber}</Field>
				<Field label={'Ad Patch Assignment'} >{store.data?.adPatchCode}</Field>
				<Field label={'Payment Schedule Patch'}>
					{
						!!order.details.feeBucketCode &&
						<Link to={`/cfi/payment-schedule/details?priceBucketID=${order.details.priceBucketID}&priceBucketVersioningID=${order.details.priceBucketVersioningID}&date=${formatDate(order.details.roDate, 'yyyy-MM-dd')}`}
							target="_blank">
							{`${order.details.feeBucketCode} (${order.details.isPromo ? 'PROMO' : 'STANDARD'})`}
						</Link>
					}
				</Field>
			</Panel>
		</>
	);
}
